<script lang="ts">
  import { INTERCOM_COPY } from "@spacecrew/shared";
  import { ship } from "../net/ship.svelte.js";
  import { session } from "../net/session.svelte.js";
  import { intercom } from "./store.svelte.js";
  import { openIntercom, setMuted } from "./media.js";
  import IntercomTile from "./IntercomTile.svelte";

  const others = $derived(Object.keys(ship.snap?.crew ?? {}).filter((id) => id !== session.sessionId));
  const debug = $derived(import.meta.env.DEV || new URLSearchParams(location.search).has("debug"));
</script>

<section aria-labelledby="intercom-title">
  <h2 id="intercom-title">INTERCOM</h2>
  {#if intercom.mode === ""}
    <p class="dim">{INTERCOM_COPY.prompt}</p>
    <div class="choices" role="group" aria-label="Open intercom">
      <button disabled={intercom.opening} onclick={() => void openIntercom("av")}>{INTERCOM_COPY.av}</button>
      <button disabled={intercom.opening} onclick={() => void openIntercom("audio")}>{INTERCOM_COPY.audio}</button>
      <button disabled={intercom.opening} onclick={() => void openIntercom("none")}>{INTERCOM_COPY.none}</button>
    </div>
  {:else}
    <div class="controls">
      <button aria-pressed={intercom.muted} onclick={() => setMuted(!intercom.muted)} disabled={intercom.mode === "none"}>
        INTERCOM {intercom.muted ? "MUTED" : "OPEN"}
      </button>
      {#if debug}
        <label class="dim">LINK QUALITY (DEBUG)
          <input type="range" min="0" max="1" step="0.01"
            value={intercom.debugQuality ?? 1}
            oninput={(e) => { intercom.debugQuality = Number((e.currentTarget as HTMLInputElement).value); }} />
          <button onclick={() => { intercom.debugQuality = null; }} disabled={intercom.debugQuality === null}>SERVER</button>
        </label>
      {/if}
    </div>
  {/if}
  {#if intercom.error}<p class="warn" role="status">{intercom.error}</p>{/if}
  <div class="bank">
    {#each others as id (id)}<IntercomTile sessionId={id} />{/each}
    {#if intercom.mode !== ""}<IntercomTile sessionId={session.sessionId} self />{/if}
    {#if !others.length}<p class="dim">NO OTHER CREW ON THIS HULL.</p>{/if}
  </div>
</section>

<style>
  .choices, .controls { display: flex; gap: 0.5rem; flex-wrap: wrap; align-items: center; margin-bottom: 0.6rem; }
  .bank { display: flex; gap: 0.6rem; flex-wrap: wrap; align-items: flex-start; }
  label { display: inline-flex; gap: 0.4em; align-items: center; font-size: 0.8em; }
  input[type=range] { width: 140px; accent-color: var(--fg); }
</style>
